
import React from 'react';
import { Card } from '@/components/ui/card';
import { SignupData } from '@/types/onboarding.d';
import { UseFormReturn } from 'react-hook-form';
import ReferralSetupForm, { ReferralSetupFormValues } from '@/components/onboarding/ReferralSetupForm';
import OnboardingSuccessView from '@/components/onboarding/OnboardingSuccessView';

interface BusinessOnboardingContentProps {
  currentStep: number;
  setupComplete: boolean;
  referralForm: UseFormReturn<ReferralSetupFormValues>;
  signupData: SignupData | null;
  isLoading: boolean;
  onboardingData: {
    companyName: string;
    subdomain: string;
  } | null;
  onSubmit: (data: ReferralSetupFormValues) => void; // Updated type signature here
  onBackStep: () => void;
  onContinue: () => void;
}

const BusinessOnboardingContent: React.FC<BusinessOnboardingContentProps> = ({
  currentStep,
  setupComplete,
  referralForm,
  signupData,
  isLoading,
  onboardingData,
  onSubmit,
  onBackStep,
  onContinue
}) => {
  return (
    <Card className="p-6 mt-8">
      {currentStep === 1 && (
        <ReferralSetupForm 
          form={referralForm}
          onSubmit={onSubmit}
          onBackStep={onBackStep}
          signupData={signupData}
          isLoading={isLoading}
        />
      )}
      
      {currentStep === 2 && (
        <OnboardingSuccessView
          setupComplete={setupComplete}
          onContinue={onContinue}
          businessName={onboardingData?.companyName || "Your Business"}
          subdomain={onboardingData?.subdomain || "yourbusiness"}
        />
      )}
    </Card>
  );
};

export default BusinessOnboardingContent;
